import { Button, styled } from '@mui/material';

export const IdmButton = styled(Button)(({ theme }) => ({
  borderRadius: 10,
  border: `1px solid ${theme.palette.grey[500]}`,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primaries[600],
  '&:hover': {
    backgroundColor: theme.palette.primaries[700],
  },
}));
